/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-22T09:43:57.667
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listHouseSchoolInfo,
	listHouseSchoolInfoInit,
	listHouseSchoolInfoByAuthorizations,
	deleteHouseSchoolInfo
} from '@api/lcf/HouseSchoolInfo';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listHouseSchoolInfo({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseSchoolInfo(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHouseSchoolInfoByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseSchoolInfoByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHouseSchoolInfoInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseSchoolInfoInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteHouseSchoolInfo({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteHouseSchoolInfo({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
